"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pluralize = void 0;
var pluralize = function (count, noun, suffix) {
    if (suffix === void 0) { suffix = 's'; }
    return "".concat(count, " ").concat(noun).concat(count !== 1 ? suffix : '');
};
exports.pluralize = pluralize;
